import { useMutation, gql } from "@apollo/client"
import { IDENTITYPROVIDER_FIELDS } from "./useQueryIdentityProviders"

const UPDATE_IDENTITYPROVIDER_MUTATION = gql`
  mutation UpdateIdentityProvider($id: ID!, $name: String!, $client: String!, $authority: String!, $browserPrompt: String, $devicePrompt: String) {
    updateIdentityProvider(id: $id, name: $name, client: $client, authority: $authority, browserPrompt: $browserPrompt, devicePrompt: $devicePrompt) {
      ${IDENTITYPROVIDER_FIELDS}
    } 
  }
`

const useMutationUpdateIdentityProvider = () => useMutation(UPDATE_IDENTITYPROVIDER_MUTATION)

export { useMutationUpdateIdentityProvider }
